import * as types from '../actionTypes';

const initialState = { 
	globalInnerLoading: false,
	globalInnerMessage: "Processando...",
	dialog:{},
	loginStatus:false,
	userProfile:"partner", // customer
	currentPartner:{},
    currentCustomer:{}}

export const appReducer = (state = initialState, action) => {
		
    switch (action.type) {
        case types.GLOBAL_LOADING:
            return { ...state, globalInnerLoading: action.payload }	
        case types.GLOBAL_MESSAGE:
            return { ...state, globalInnerMessage: action.payload }	
        case types.SET_DIALOG:
            return { ...state, dialog: action.payload }	
        case types.SET_LOGINSTATUS:
            return { ...state, loginStatus: action.payload }	
        case types.SET_USERPROFILE:
            return { ...state, userProfile: action.payload }		
        case types.SET_CURRENTPARTNER:
            return { ...state, agencyName: action.payload }	
        case types.SET_CURRENTCUSTOMER:
            return { ...state, agencyUser: action.payload }				
        default:
            return state
    }
	
}